<template>
  <footer class="footer">
    <div class="container">
      <div class="footer__wrapper">
        <div class="footer__left">
          <router-link class="footer__logo" :to="translations.i18nRoute({ name: 'home' })">
            <img src="@images/logo-footer.png" alt="logo">
          </router-link>
          <div class="footer__info">
            <p>{{ t('footer.company')}}</p>
            <p>{{ t('footer.rights')}}</p>
          </div>
          <base-language />
          <div class="footer__left-links">
            <a href="https://www.instagram.com/digital_card_house/"><img src="@icons/inst.svg" alt=""></a>
            <a href="https://t.me/digitalcardhouse"><img src="@icons/tg.svg" alt=""></a>
            <!-- TrustBox widget - Review Collector -->
            <div
                id="trustbox"
                class="trustpilot-widget"
                data-locale="en-GB"
                data-template-id="56278e9abfbbba0bdcd568bc"
                data-businessunit-id="697c5a20fbe9ca0a4727b0f9"
                data-style-height="52px"
                data-style-width="100%"
                data-token="8c163033-dbe7-43cf-8505-5dda8b3622a8"
            >
              <a href="https://www.trustpilot.com/review/digitalcardhouse.com" target="_blank" rel="noopener">Trustpilot</a>
            </div>
            <!-- End TrustBox widget -->
          </div>
          <div style="display: flex; align-items: center">
            <img src="@images/masterCard.png" alt="" style="height: 45px;" />
            <img src="@images/visa.png" alt="" style="height: 30px;">
          </div>
        </div>
        <div class="footer__columns">
          <div class="footer__column">
            <h6>{{ t('footer.column1')}}</h6>
            <div class="footer__column-items">
              <a href="mailto:team@digitalcardhouse.com"><img src="@icons/mail.svg" alt="@">team@digitalcardhouse.com</a>
              <p><img src="@icons/address.svg" alt="">128 City Road, London, United Kingdom, EC1V 2NX.</p>
              <a href="tel:+447463083214"><img src="@icons/phone.svg" alt="">+44 7463 083214</a>
            </div>
          </div>
          <div class="footer__column">
            <h6>{{ t('footer.column2') }}</h6>
            <div class="footer__column-items">
              <router-link
                  :to="translations.i18nRoute({ name: 'market', query: { categoriesSlugs: category.node.slug } })"
                  v-for="category in categories"
                  :key="category.node.uuid"
              >
                {{ category.node.name }}
            </router-link>
            </div>
          </div>
          <div class="footer__column">
            <h6>{{ t('footer.column3') }}</h6>
              <div class="footer__column-items">
                <router-link :to="translations.i18nRoute({ name: 'about' })">{{ t('docs.aboutUs.title') }}</router-link>
                <router-link :to="translations.i18nRoute({ name: 'policy' })">{{ t('docs.policy.title') }}</router-link>
                <router-link :to="translations.i18nRoute({ name: 'terms' })">{{ t('docs.terms.title') }}</router-link>
                <router-link :to="translations.i18nRoute({ name: 'faq' })">{{ t('docs.faq.title') }}</router-link>
              </div>
            </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import translations from "@/core/helpers/translations.js";
import {useCompanyStore} from "@/stores/company.js";
import {computed, onMounted} from "vue";
import {useI18n} from "vue-i18n";
import {useCategoryStore} from "@/stores/category.js";
import BaseLanguage from "@/components/base/base-language.vue";

const companyStore = useCompanyStore()
const categoryStore = useCategoryStore()
const {t} = useI18n()

const company = computed(() => {
  return companyStore.companyInfo ? companyStore.companyInfo : null
})

const companyName = computed(() => {
  if (!company.value?.companyName) return '';
  const [text] = company.value.companyName.split(',').map((part) => part.trim());
  return text;
});

const categories = computed(() => categoryStore.categories)

const actualYear = computed(() => new Date().getFullYear());

onMounted(() => {
  if (window.Trustpilot) {
    const box = document.getElementById('trustbox')
    const a = window.Trustpilot.loadFromElement(box)
  }
})
</script>

<style lang="scss" scoped>
.footer {
  border-top: 2px solid #5A5BC8;

  &__wrapper {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding-block: 80px 40px;
  }

  &__left {
    display: flex;
    flex-direction: column;
    gap: 40px;

    &-links{
      display: flex;
      gap: 10px
    }
  }

  &__logo {
    & img {
      width: 290px;
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    gap: 20px;



    &-link {
      display: flex;
      align-items: center;
      gap: 10px;

      @include hover {
        & p {
          color: #c5c5c5;
        }
      }

      & h6 {
        color: #3B3B3B;
        font-size: 24px;
        font-weight: 500;
        line-height: 29.412px;
      }

      & p {
        transition: 0.2s;
        color: #3B3B3B;
        font-weight: 600;
        line-height: 20px;
        font-size: 16px;
      }
    }
  }

  &__columns {
    display: flex;
    align-items: flex-start;
    gap: 75px
  }

  &__column {
    display: grid;
    gap: 30px;

    & h6 {
      padding-bottom: 10px;
      border-bottom: 3px solid #5A5BC8;

      color: #3B3B3B;
      font-size: 20px;
      font-weight: 800;
      line-height: 20px;
    }

    & p, a {
      cursor: pointer;
      transition: 0.2s;
      color: #3B3B3B;
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      display: flex;
      align-items: center;
      gap: 10px;

      @include hover {
        color: #DD6196;
      }
    }

    &-items{
      display: grid;
      gap: 10px;
      grid-template-rows: repeat(5, 1fr);
      grid-template-columns: auto;
    }
  }

  &__bottom {

    &-wrapper {
      padding-block: 25px;

      & p {
        text-align: center;
        color: #3B3B3B;
        font-size: 20px;
        font-weight: 400;
        line-height: 20px;
      }
    }
  }
}

@media (max-width: 1100px){
  .footer__wrapper{
    flex-direction: column;
  }
}

@media (max-width: 900px) {
  .footer {
    &__wrapper {
      flex-direction: column;
      align-items: center;
      gap: 50px;
    }

    &__left {
      align-items: center;
    }
  }
}

@media (max-width: 750px) {
  .footer {
    &__columns {
      flex-direction: column;
      padding-left: 50px;
      gap: 50px;
    }

    &__column {
      align-items: center;

      &-items{
        grid-template-columns: unset;
        grid-template-rows: unset;
      }
    }

    &__bottom {
      &-wrapper {
        & p {
          font-size: 14px;
        }
      }
    }
  }
}
</style>